import { useCallback, useState } from 'react';
import { OPEN_APP_BANNER_DISMISSED_STORAGE_KEY } from './constants';

function isDismissedToday(): boolean {
	try {
		return localStorage.getItem(OPEN_APP_BANNER_DISMISSED_STORAGE_KEY) === new Date().toDateString();
	} catch {
		return false;
	}
}


export function useOpenAppBannerDismissed() {
	const [isDismissed, setIsDismissed] = useState(isDismissedToday);

	const dismiss = useCallback(() => {
		setIsDismissed(true);
		try {
			localStorage.setItem(OPEN_APP_BANNER_DISMISSED_STORAGE_KEY, new Date().toDateString());
		} catch (error) {
			console.warn('Failed to persist open-app banner dismissal', error);
		}
	}, []);

	return { isDismissed, dismiss };
}
